// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"1516f4fd","84":"3d74d869","127":"a208222e","200":"f9fcfb67","282":"979445dd","476":"b39926d6","568":"657b630b","583":"a452bf8f","606":"243599b7","640":"3e1ecdbb","871":"4dd65a0b","883":"87691eb7"}[chunkId] + ".chunk.js";
};